import { useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../../../../api';
import { ICargo, INftAsset } from '../../../../interfaces';
import { Utils } from '../../../../utils';

export const NftHomeBanner = () => {
  const projectCode = 'NFT';
  const api = useApi(projectCode);
  const navitate = useNavigate();
  const [mounted, setMounted] = useState<Boolean>(false);
  const [assets, setAssets] = useState<INftAsset[]>([]);
  
  useEffect(() => {
    if (mounted) return;
    setMounted(true);
    api.getNftHotFavorites((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setAssets(cargo.info);
      }
    })
  }, [api, mounted])

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 960 },
      items: 3,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 960, min: 680 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 680, min: 300 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };
  return (
    <>
      <Carousel
        additionalTransfrom={0}
        arrows
        autoPlay={false}
        autoPlaySpeed={5000}
        centerMode={false}
        className=""
        containerClass="container-with-dots"
        dotListClass="custom-dot-list-style"
        draggable={false}
        focusOnSelect={false}
        infinite
        itemClass=""
        keyBoardControl
        minimumTouchDrag={80}
        pauseOnHover
        removeArrowOnDeviceType={["tablet", "mobile"]}
        renderArrowsWhenDisabled={false}
        renderButtonGroupOutside={false}
        renderDotsOutside={false}
        responsive={responsive}
        rewind={false}
        rewindWithAnimation={false}
        rtl={false}
        shouldResetAutoplay
        showDots={true}
        swipeable={true}
      >
        {
          assets.map((asset: INftAsset) => {
            return (
              <div key={asset.nftId} onClick={() => {
                navitate(`/web/asset/detail/${asset.nftId}`);
              }}>
                <div className="cards d-flex flex-column justify-content-between align-items-center mx-auto w-100" style={{ height: '300px', maxWidth: '95%' }}>
                  <div className="d-flex justify-content-center align-items-baseline" style={{ height: '220px' }}>
                    <img src={Utils().normalizeImagePath(asset.image, projectCode)} alt={asset.name}
                      className="" style={{ maxHeight: '100%', maxWidth: '100%' }} />
                  </div>
                  <div className="p-3 weight-600">
                    {asset.name}
                  </div>
                </div>
              </div>
            )
          })
        }
      </Carousel>
    </>
  )
}